import { Box, HStack, Link, Text } from '@wegroup/design-system';
import cogoToast from 'cogo-toast';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useDebouncedCallback } from 'use-debounce/lib';
import { getEnterprisesByName } from '../../../../../../common/src/legacy/services/apiRouterService';
import {
  Enterprise,
  ReturnOptionProps,
} from '../../../../../../../types/ProductFactory';
import SearchSelectInputV2 from '../../../../../../common/src/components/SearchSelectInputV2';

interface CompanyOption {
  value: Enterprise;
  label: string;
}

interface Props {
  handleOnChange: (arg0: boolean | Enterprise) => void;
  onCantFind: () => void;
}

const CbeSearchInput: React.FC<React.PropsWithChildren<Props>> = ({
  handleOnChange,
  onCantFind,
  ...otherProps
}) => {
  const { t } = useTranslation();

  const fetchCbeCompanies = async (
    keyword: string,
    cb: (arg0: CompanyOption[]) => void,
  ) => {
    if (keyword.length > 1) {
      const [resp, status] = await getEnterprisesByName(keyword);

      if (status !== 200 && resp.msg === 'ENTERPRISE_NOT_FOUND') {
        return cb([]);
      } else if (status !== 200) {
        return cogoToast.error(t('Something went wrong'));
      }

      cb(
        (resp.items as Enterprise[])
          .filter(({ address }) => address?.country_code === 'BE')
          .map((company) => ({
            value: company,
            label: `${company.cbe} - ${company.name}` || '',
          })),
      );
    }
    return cb([]);
  };

  const [debounceFetchCbeCompanies] = useDebouncedCallback(
    fetchCbeCompanies,
    500,
  );

  const handleSelected = (p: ReturnOptionProps) => {
    handleOnChange(p.value as Enterprise);
  };

  return (
    <Box w="100%" {...otherProps}>
      <StyledSearchSelectInputV2
        async
        isClearable
        name="address_search"
        onSelected={handleSelected}
        loadOptions={debounceFetchCbeCompanies}
        placeholder={t(`CBE number`)}
      />

      <HStack justifyContent="space-between" mt={4} color="text.gray">
        <Text>{t('Give at least 2 numbers')}</Text>
        <Link variant="gray" onClick={onCantFind}>
          {t("I can't find my company")}
        </Link>
      </HStack>
    </Box>
  );
};

const StyledSearchSelectInputV2 = styled(SearchSelectInputV2)`
  background: white;
`;

export default CbeSearchInput;
